<template>
  <div>
    <div v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <header class="header-panel">
        <div class="header-panel__content--mobile">
          <slot name="header-icon" v-if="headerIcon">
            <div
              class="header-panel__icon"
              :class="`grunticon__icon-${headerIcon}`"
            ></div>
          </slot>
          <slot name="heading-left">
            <h3
              class="header-panel__text h3"
              v-if="headerText"
              :class="{
                'apioshade2--text': !isDarkMode,
                'apioshade4--text': isDarkMode,
              }"
            >
              {{ headerText }}
            </h3>
            <slot name="header-cta" />
        <v-spacer v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"/>
            <slot name="activator"></slot>
          </slot>
        </div>
        <div class="mt-4"><slot name="header-search" /> <slot></slot></div>
        <div class="header-panel__pagination">
          <slot name="header-items-per-page" /><slot name="header-pagination" />
        </div>
        <div><slot name="header-filter" /></div>
      </header>
    </div>

    <div v-else>
      <header class="header-panel">
        <div class="header-panel__content">
          <slot name="header-icon" v-if="headerIcon">
            <div
              class="header-panel__icon"
              :class="`grunticon__icon-${headerIcon}`"
            ></div>
          </slot>
          <slot name="heading-left">
            <h1
              class="header-panel__text h1"
              :class="{
                'apioshade2--text': !isDarkMode,
                'apioshade4--text': isDarkMode,
              }"
            >
              {{ headerText }}
            </h1>
          </slot>
          <div class="d-flex ml-1">
            <div class="mx-4">
              <slot name="header-search"/>
            </div>
            <div class="mr-4"><slot></slot></div>
            <slot name="header-cta" />
          </div>
        </div>
        <div class="header-panel__pagination">
          <slot name="activator"></slot>
          <span class="mr-4"><slot name="header-items-per-page" /></span
          ><slot name="header-pagination" />
        </div> 
        <slot name="header-right" />
      </header>
    </div>

    <div class="header-panel__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPanel",
  props: {
    headerText: {
      type: String,
      required: false,
    },
    headerIcon: {
      type: String,
      required: false,
    },
  },
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-panel {
  max-width: 1440px;
  @media (min-width: 960px) {
    display: flex;
    justify-content: space-between;
  }

  &__pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__content {
    display: flex;
    align-items: center;
    &--mobile {
      display: flex;
      align-items: center;
    }
  }

  &__icon {
    background-size: cover;
    height: 54px;
    margin-right: 16px;
    width: 61px;
  }

  &__actions {
    width: 100%;
    display: flex;
  }
}

@media (max-width: 1024px) {
  .header-panel {
    &__icon {
      background-size: cover;
      height: 24px;
      margin-right: 16px;
      width: 27px;
    }
  }
}
</style>